export const APPOINTMENT_STATUS_AWAITING_CONFIRMATION = 1;
export const APPOINTMENT_STATUS_APPROVED = 2;
export const APPOINTMENT_STATUS_STARTED = 3;
export const APPOINTMENT_STATUS_COMPlETED = 4;
export const APPOINTMENT_STATUS_CANCELED = 5;
export const APPOINTMENT_STATUS_REJECTED = 6;
export const APPOINTMENT_STATUS_FINISHED = 7;

export const APPOINTMENT_STATUSES = {
  awaiting_confirmation: APPOINTMENT_STATUS_AWAITING_CONFIRMATION,
  approved: APPOINTMENT_STATUS_APPROVED,
  started: APPOINTMENT_STATUS_STARTED,
  completed: APPOINTMENT_STATUS_COMPlETED,
  canceled: APPOINTMENT_STATUS_CANCELED,
  rejected: APPOINTMENT_STATUS_REJECTED,
  finished: APPOINTMENT_STATUS_FINISHED
} as const;

export const APPOINTMENT_STATUS_VALUES = {
  [APPOINTMENT_STATUS_AWAITING_CONFIRMATION]: 'awaiting_confirmation',
  [APPOINTMENT_STATUS_APPROVED]: 'approved',
  [APPOINTMENT_STATUS_STARTED]: 'started',
  [APPOINTMENT_STATUS_COMPlETED]: 'completed',
  [APPOINTMENT_STATUS_CANCELED]: 'canceled',
  [APPOINTMENT_STATUS_REJECTED]: 'rejected',
  [APPOINTMENT_STATUS_FINISHED]: 'finished'
};

export type AppointmentStatusType = keyof typeof APPOINTMENT_STATUS_VALUES;

// CREATORS

export const APPOINTMENT_CREATOR_ADMIN = 1;
export const APPOINTMENT_CREATOR_PATIENT = 2;
export const APPOINTMENT_CREATOR_DOCTOR = 3;

export const APPOINTMENT_CREATOR = {
  admin: APPOINTMENT_CREATOR_ADMIN,
  patient: APPOINTMENT_CREATOR_PATIENT,
  doctor: APPOINTMENT_CREATOR_DOCTOR
} as const;

export const APPOINTMENT_VIEW_DASHBOARD = {
  [APPOINTMENT_STATUS_APPROVED]: 'approved_appointments',
  [APPOINTMENT_STATUS_AWAITING_CONFIRMATION]: 'request'
} as const;

export enum BinaryChoiceEnum {
  Yes = 1,
  No = 0
}

export const BinaryChoiceConstant: { [key: number]: string } = {
  1: 'yes',
  0: 'no'
} as const;
